<div class="delete-complete">
  <div class="icon-container">
    <img class="image-success" src="{{successImage}}" alt="">
  </div>
  <div class="title-container">
    <h1 style="font-weight: bold;">{{ 'delete_completed.title' | translate }}</h1>
  </div>
  <div class="low-btn-container">
    <button class="my-button" (click)="goToEventList()">{{ 'back_event' | translate }}</button>
    @if (userService.isEmployeeWithoutPassenger() || userService.uuidPassenger) {
      <button class="my-button" (click)="termina()">
        {{ 'finish_operations' | translate }}
      </button>
    }
  </div>
</div>
